if (!customElements.get('athilco-product-gallery-v2')) {
  customElements.define('athilco-product-gallery-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.dialog = this.querySelector('dialog');
      this.index = 0;
      this.addEventListener('click', event => {
        if (this.suppressClick) {event.preventDefault();this.suppressClick=false;return;}
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-index')) this.select(Number(button.dataset.index));
        if (button.hasAttribute('data-step')) this.select(this.index + Number(button.dataset.step));
        if (button.hasAttribute('data-open') || button.hasAttribute('data-open-media')) {this.opener=button;this.dialog.showModal();this.renderFull();}
        if (button.hasAttribute('data-close')) this.dialog.close();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.target.closest('video,iframe,model-viewer')) return;
        if (event.key==='ArrowRight' || event.key==='ArrowLeft') {
          event.preventDefault();this.select(this.index+(event.key==='ArrowRight'?1:-1));
          if(event.target.hasAttribute('data-index')) {
            const group=event.target.closest('.athilco-gallery__thumbs');
            group.querySelector(`[data-index="${this.index}"]`).focus({preventScroll:true});
          }
        }
      },options);
      this.addEventListener('pointermove', event => {
        if(event.pointerType!=='mouse') return;
        const button=event.target.closest('[data-open]');
        if(!button) return;
        const box=button.getBoundingClientRect();
        button.style.setProperty('--ag-x',`${Math.max(0,Math.min(100,(event.clientX-box.left)/box.width*100))}%`);
        button.style.setProperty('--ag-y',`${Math.max(0,Math.min(100,(event.clientY-box.top)/box.height*100))}%`);
      },options);
      this.querySelectorAll('.athilco-gallery__stage,.athilco-gallery__lightbox-stage').forEach(stage=>{
        stage.addEventListener('pointerdown',event=>{
          if(event.pointerType==='mouse'||event.target.closest('video,iframe,model-viewer,.athilco-gallery__arrow')) return;
          this.touchStart={x:event.clientX,y:event.clientY};
        },options);
        stage.addEventListener('pointerup',event=>{
          if(!this.touchStart) return;
          const x=event.clientX-this.touchStart.x,y=event.clientY-this.touchStart.y;
          this.touchStart=null;
          if(Math.abs(x)>45&&Math.abs(x)>Math.abs(y)*1.5){this.suppressClick=true;this.select(this.index+(x<0?1:-1));setTimeout(()=>{this.suppressClick=false;},300);}
        },options);
        stage.addEventListener('pointercancel',()=>{this.touchStart=null;},options);
      });
      this.querySelectorAll('.athilco-gallery__thumbs').forEach(row=>{
        let drag;
        row.addEventListener('pointerdown',event=>{
          if(event.pointerType!=='mouse'||event.button!==0)return;
          drag={id:event.pointerId,x:event.clientX,left:row.scrollLeft,moved:false};
        },options);
        row.addEventListener('pointermove',event=>{
          if(!drag||event.pointerId!==drag.id)return;
          const distance=event.clientX-drag.x;
          if(!drag.moved&&Math.abs(distance)>5){drag.moved=true;row.setPointerCapture(drag.id);row.classList.add('is-dragging');}
          if(drag.moved){event.preventDefault();row.scrollLeft=drag.left-distance;}
        },options);
        const finish=()=>{
          if(drag?.moved){this.suppressClick=true;setTimeout(()=>{this.suppressClick=false;},0);}
          if(drag&&row.hasPointerCapture(drag.id))row.releasePointerCapture(drag.id);
          drag=null;row.classList.remove('is-dragging');
        };
        row.addEventListener('pointerup',finish,options);
        row.addEventListener('pointercancel',finish,options);
        row.addEventListener('pointerleave',()=>{if(drag&&!drag.moved)finish();},options);
      });
      this.dialog.addEventListener('close',()=>{
        this.querySelector('[data-full-host]').replaceChildren();
        this.select(this.index);
        this.panels[this.index]?.querySelector('[data-open],[data-open-media]')?.focus({preventScroll:true});
      },options);
      this.resize=()=>this.fit();
      window.addEventListener('resize',this.resize,options);
      window.visualViewport?.addEventListener('resize',this.resize,options);
      window.addEventListener('load',this.resize,options);
      this.observer=new ResizeObserver(this.resize);
      this.observer.observe(this.closest('.main-product__image'));
      this.select(0);
      this.fit();
      document.fonts?.ready.then(()=>{if(this.isConnected)this.fit();});
    }
    disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();if(this.dialog?.open)this.dialog.close();}
    fit(){
      const anchor=this.closest('.main-product__image');
      if(!anchor)return;
      const top=anchor.getBoundingClientRect().top+window.scrollY;
      const preview=document.querySelector('#preview-bar-iframe');
      const bottom=preview ? Math.max(16,window.innerHeight-preview.getBoundingClientRect().top+12) : 20;
      this.style.setProperty('--ag-top',`${Math.max(0,top)}px`);
      this.style.setProperty('--ag-bottom',`${Math.min(90,bottom)}px`);
    }
    pause(panel){
      panel.querySelectorAll('video').forEach(video=>video.pause());
      panel.querySelectorAll('iframe').forEach(frame=>frame.remove());
    }
    select(index){
      if(!this.panels.length)return;
      this.index=(index+this.panels.length)%this.panels.length;
      this.panels.forEach((panel,i)=>{panel.hidden=i!==this.index;if(panel.hidden)this.pause(panel);});
      const panel=this.panels[this.index],host=panel.querySelector('[data-media-host]'),template=panel.querySelector('template');
      if(host&&template&&!host.querySelector('video,iframe,model-viewer'))host.replaceChildren(template.content.cloneNode(true));
      this.querySelectorAll('[data-index]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.index)===this.index)));
      this.querySelectorAll('[data-counter]').forEach(counter=>counter.textContent=`${this.index+1} / ${this.panels.length}`);
      this.querySelector('.athilco-gallery__toolbar').style.visibility=panel.dataset.kind==='image'?'visible':'hidden';
      this.revealThumbnail();
      if(this.dialog.open)this.renderFull();
    }
    revealThumbnail(){
      this.querySelectorAll('.athilco-gallery__thumbs').forEach(row=>{
        if(!row.clientWidth)return;
        const button=row.querySelector(`[data-index="${this.index}"]`);
        if(!button)return;
        const frame=row.getBoundingClientRect(),thumb=button.getBoundingClientRect();
        if(thumb.left<frame.left+4)row.scrollLeft+=thumb.left-frame.left-4;
        else if(thumb.right>frame.right-4)row.scrollLeft+=thumb.right-frame.right+4;
      });
    }
    renderFull(){
      this.revealThumbnail();
      const panel=this.panels[this.index],host=this.querySelector('[data-full-host]');
      this.panels.forEach(panel=>this.pause(panel));
      const original=panel.querySelector('[data-open]');
      if(original){
        const img=new Image();img.alt=original.querySelector('img').alt;img.src=original.dataset.full;img.decoding='async';host.replaceChildren(img);
      }else{
        host.replaceChildren(panel.querySelector('template').content.cloneNode(true));
      }
    }
  });
}
